import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ProcessActivityView } from '@app/pages/admin/orchestration-process-activity.util';

@Component({
  selector: 'app-orchestration-process-activity',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './orchestration-process-activity.html',
  styleUrl: './orchestration-process-activity.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrchestrationProcessActivityComponent {
  readonly activity = input<ProcessActivityView | null>(null);
}
